module.exports = __webpack_public_path__ + "static/media/primary_resume.965fb62f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/primary_resume.pdf
// module id = 106
// module chunks = 2